import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import SvgSliderArrow from "./SvgSliderArrow";
import useIsRtl from "@/hooks/useIsRtl";
import useEmblaSlider from "./useEmblaSlider";

type UsePrevNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
  emblaApi: EmblaCarouselType | undefined,
): UsePrevNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

type TProps = {
  onLastSlide?: (isLastSlide: boolean) => void;
  hidden?: boolean;
};
const EmblaSliderPrevNextButtons: React.FC<TProps> = ({
  onLastSlide,
  hidden,
}) => {
  const isRtl = useIsRtl();
  const [, emblaApi] = useEmblaSlider()!;
  const {
    nextBtnDisabled,
    onNextButtonClick,
    onPrevButtonClick,
    prevBtnDisabled,
  } = usePrevNextButtons(emblaApi);
  const canScrollNext = emblaApi?.canScrollNext();

  return (
    !hidden && (
      <>
        <SvgSliderArrow
          disabled={isRtl ? prevBtnDisabled : nextBtnDisabled}
          onClick={() => {
            isRtl ? onPrevButtonClick() : onNextButtonClick();
            if (onLastSlide) {
              !isRtl && onLastSlide(!!canScrollNext);
            }
          }}
        />
        <SvgSliderArrow
          left
          disabled={isRtl ? nextBtnDisabled : prevBtnDisabled}
          onClick={() => {
            isRtl ? onNextButtonClick() : onPrevButtonClick();
            if (onLastSlide) {
              isRtl && onLastSlide(!!canScrollNext);
            }
          }}
        />
      </>
    )
  );
};
export default EmblaSliderPrevNextButtons;
